import React,{useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import Barcode from "react-barcode";
import Toast from '../../../../plugins/useToast'

import {ReactComponent as IconCloseBlack } from '../../../../assets/icons/ic-close-black.svg';
import {ReactComponent as IconArrowLeft } from '../../../../assets/icons/ic-arrow-left-black.svg';
import {ReactComponent as IconArrowRight } from '../../../../assets/icons/ic-arrow-right-black.svg';

const BarcodePrint = ({selectedDevices, onClose}) => {       
    const { t } = useTranslation() 
    const [chkDischarge, setChkDischarge] = useState(false)
    const [barcodeData, setBarcodeData] = useState()
    const [pagingInfo, setPagingInfo] = useState({
        currentPage: 1,
        totalPages : 0,        
        totalCount : 0
    });

    // ✅ 페이지 이동 함수
    const goToPage = (page) => {
        if (page < 1 || page > pagingInfo.totalPages) return;
        console.log('goToPage', page);
        setPagingInfo((prev) => ({ ...prev, currentPage: page }));        
    };

    // 프린트 함수
    const handelBarcodePrint = () => {
        const barcodeArray = barcodeData.filter(item => item?.bedNumber !== 'Discharge').map(item => item.id);                

        const params = {
            discharge: chkDischarge,
            devices: encodeURIComponent(JSON.stringify(barcodeArray)) || [],
        }        

        const windowFeatures = "width=1200,height=800,left=100,top=100,scrollbars=yes,resizable=yes";        
        const setUrl = `${window.location.origin}/print/barcodeform?discharge=${params.discharge}&devices=${params.devices}`;
        console.log('setUrl', setUrl);
        const newWindow = window.open(setUrl, "popupWindow", windowFeatures);
        if (newWindow) {
            newWindow.focus();
        } else {
            Toast({ isSuccess: false, msg: t('error.failOpenPage') })
        }
    }

    useEffect(() => {      
        if(chkDischarge){
            //chkDischarge가 true이면 객체 첫번째로 {bedNumber : 'Discharge', value : 'Discharge'} 추가 하고 싶은데
            const addDischarge = [{bedNumber : 'Discharge', serial : 'Discharge'}];
            setBarcodeData(prev => ([...addDischarge, ...selectedDevices]));
        }else{
            setBarcodeData(selectedDevices);
        }
    }, [chkDischarge])

    //데이터 넣어주기
    useEffect(() => {  
        console.log('selectedDevices', selectedDevices);     
        setBarcodeData(selectedDevices);
    }, [])    

    useEffect(() => {
        if(!barcodeData || barcodeData.length === 0){
            return;
        }
        console.log('barcodeData : ',barcodeData);
        const totalCount = barcodeData.length + (chkDischarge ? 1 : 0);
        const totalPages = Math.ceil(totalCount / 21); //21개까지 데이터가 가능하니까
        setPagingInfo(prev => ({ ...prev, totalCount, totalPages, currentPage: 1 }));
    }, [barcodeData]);

    return (
        <div className="absolute w-full h-full content-center whitespace-pre-line" style={{ top: 0, left: 0, background: 'rgba(0,0,0,0.3)', zIndex : 99999 }}>
            <div className="mx-auto w-[544px] h-[871px] bg-[#DEDEDE] text-center flex flex-col rounded-[8px]">
                <div className="flex h-[38px] bg-[#CECECE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]">
                    <div className="">{t('admin.device.barcodePrint')}</div>
                    <IconCloseBlack className="ml-auto cursor-pointer" onClick={() => { onClose() }}/>
                </div>
                <div className='flex-1'>
                    <div className='flex justify-between items-center p-[20px]'>
                        <div className='flex items-center'>
                            <span className='text-[16px] font-normal leading-[110%] text-[#000]'>{t('admin.device.preview')}</span>
                        </div>
                        <div className='flex'>
                            <label className="flex items-center gap-[4px] cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={chkDischarge}   
                                    onChange={e => setChkDischarge(e.target.checked)}
                                />
                                <span className="font-light">{t('admin.device.includeDischargeBarcode')}</span>
                            </label>
                        </div>
                    </div>
                    <div className='flex flex-wrap justify-start gap-x-[12px] gap-y-[12px] px-[20px] mb-[8px]'>
                        {/* 여기 filter로 페이징 데이터만 표기 할 수 있게 하고싶은데 어떻게 해야될까? */}
                        {
                            barcodeData && barcodeData.filter((device, index) => {
                                const startIndex = (pagingInfo.currentPage - 1) * 21;
                                const endIndex = startIndex + 21;
                                return index >= startIndex && index < endIndex;
                            }).map((device, index) => {
                                return (
                                    <div className='w-[160px] h-[91px] bg-[#fff] flex flex-col justify-center items-center px-[8px] py-[10px] rounded-[4px]' key={`barcode-${index}`}>
                                        <p className='text-[#000] text-center font-pretendard text-[16px] font-medium leading-[110%] mb-[8px]'>{device.bedNumber == 'Discharge' ? device.bedNumber : `BED-${device.bedNumber}`}</p>
                                        <div className='mb-[4px]'>
                                            <Barcode value="000000000000" format="CODE128" width={1} height={32} displayValue={false} margin={0} />
                                        </div>
                                        <p className='text-[#000] text-center font-pretendard text-[11px] font-normal leading-[110%] tracking-[2.2px]'>{device.serial}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='w-full flex justify-between items-center px-[20px] py-[12px]'>
                    <div className='flex items-center justify-start'>
                        {/* 여기에 currentPage, totalPages를 계산해서 1이면  */}
                        <IconArrowLeft className={`${pagingInfo.currentPage == 1 ? 'opacity-30' : 'cursor-pointer'}`} onClick={() => { goToPage(pagingInfo.currentPage - 1) }} />
                        <p className='mx-[12px] text-[#000] text-center font-pretendard text-[16px] font-light leading-[110%]'>
                            <span className="font-bold">{pagingInfo.currentPage}</span> / {pagingInfo.totalPages}
                        </p>
                        <IconArrowRight className={`${pagingInfo.currentPage == pagingInfo.totalPages ? 'opacity-30' : 'cursor-pointer'}`} onClick={() => { goToPage(pagingInfo.currentPage + 1) }} />
                    </div>
                    <div className="flex items-center justify-end bg-[#DEDEDE] rounded-bl-[8px] rounded-br-[8px]">
                        <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] mr-[8px]  gap-[8px] rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] cursor-pointer text-[#000] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={() => { onClose() }}>{t('admin.cancel')}</div>
                        <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] cursor-pointer text-[#FFF] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={() => { handelBarcodePrint() }} >{t('admin.device.print')}</div>                    
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BarcodePrint